import axios from "axios";
import apiClient from "@/axios";
import endpoints from "@/endpoints";
import { withHealthUserId } from "@/services/health/health";

function createOrderObject(productVariant, deliver_to, bill_to, shipping, amount) {
    return {
        cart: {
            rows: [
                {
                    sku: productVariant.sku,
                    qty: 1,
                },
            ],
            shipping: shipping ? shipping : "",
            countryCode: deliver_to.countryCode,
        },
        currency: productVariant.currency,
        deliver_to: deliver_to?.lineOne ? deliver_to : bill_to,
        bill_to,
        amount,
    };
}

// Function to generate a unique correlation ID
function generateCorrelationId() {
    return `paypal-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

class OrderService {
    static async createPaypalOrder(
        barcode,
        productVariant,
        deliver_to,
        bill_to,
        shipping,
        amount,
        token
    ) {
        return {
            barcode,
            order: createOrderObject(productVariant, deliver_to, bill_to, shipping, amount),
            paymentMethod: "paypal",
            paymentToken: token,
        };
    }

    static async getShippingOptions(sku, country) {
        const {
            data: { shippingMethods },
        } = await axios.get(`${endpoints.shippingOptions}?sku=${sku}&countryCode=${country}`);
        return shippingMethods;
    }

    // Updated to accept correlationId parameter
    static async confirmPaypalOrder(order, correlationId = null) {
        // Generate correlation ID if not provided
        const corrId = correlationId || generateCorrelationId();
        
        const config = {
            headers: {
                'X-Correlation-Id': corrId
            }
        };
        
        console.log(`Confirming PayPal order with correlation ID: ${corrId}`);
        // Store correlation ID for debugging
        if (order) {
            order.correlationId = corrId;
        }
        
        return apiClient.post(endpoints.checkout, await withHealthUserId(order), config);
    }

    static async createPaymentIntentForOrder(order, correlationId = null) {
        const corrId = correlationId || generateCorrelationId();
        
        const config = {
            headers: {
                'X-Correlation-Id': corrId
            }
        };
        
        console.log(`Creating payment intent with correlation ID: ${corrId}`);
        
        return axios.post(endpoints.createPaymentIntent, await withHealthUserId(order), config);
    }

    static async checkoutOrder(order, correlationId = null) {
        const corrId = correlationId || generateCorrelationId();
        
        const config = {
            headers: {
                'X-Correlation-Id': corrId
            }
        };
        
        console.log(`Checking out order with correlation ID: ${corrId}`);
        
        return axios.post(endpoints.checkout, await withHealthUserId(order), config);
    }
}

export default OrderService;